import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ClientProfileComponent } from './pages/client-profile/client-profile.component'
import { ClientListComponent } from './pages/client-list/client-list.component'
import { ClientsRoutingModule } from './clients-routing.module'
import { ClientTableComponent } from './components/client-table/client-table.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { ClientProfileTableComponent } from './components/client-profile-table/client-profile-table.component'
import { ClientFilterComponent } from './components/client-filter/client-filter.component'
import { WalletModule } from '../wallet/wallet.module'
import { ClientWalletFilterComponent } from './components/client-wallet-filter/client-wallet-filter.component'
import { ClientWalletHistoryComponent } from './components/client-wallet-history/client-wallet-history.component'
import { ClientPayoutsComponent } from './components/client-payouts/client-payouts.component'
import { AcceptRejectPayoutComponent } from './components/accept-reject-payout/accept-reject-payout.component'
import { ClientProfilePayoutFilterComponent } from './components/client-profile-payout-filter/client-profile-payout-filter.component';
import { ClientProfilePayoutDetailsComponent } from './components/client-profile-payout-details/client-profile-payout-details.component'
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { ShowReasonPopupComponent } from './components/show-reason-popup/show-reason-popup.component'
import { MatDialogModule } from '@angular/material/dialog'

@NgModule({
	declarations: [
		ClientProfileComponent,
		ClientListComponent,
		ClientTableComponent,
		ClientFilterComponent,
		ClientProfileTableComponent,
		ClientWalletFilterComponent,
		ClientWalletHistoryComponent,
		ClientPayoutsComponent,
		AcceptRejectPayoutComponent,
		ClientProfilePayoutFilterComponent,
  ClientProfilePayoutDetailsComponent,
  ShowReasonPopupComponent,
	],
	imports: [CommonModule, ClientsRoutingModule, SharedModule, WalletModule,MatDialogModule],
	exports:[ShowReasonPopupComponent],
	providers: [
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
	],
})
export class ClientsModule {}
